import {
  GET_DOCUMENT_TYPES,
  GET_DOCUMENT_TYPES_SUCCESS,
  DOCUMENT_TYPE_API_ERROR,
} from "./actionTypes";

export const getDocumentTypes = () => ({
  type: GET_DOCUMENT_TYPES,
});

export const getDocumentTypesSuccess = documentTypes => ({
  type: GET_DOCUMENT_TYPES_SUCCESS,
  payload: documentTypes,
});

export const documentTypeApiError = error => ({
  type: DOCUMENT_TYPE_API_ERROR,
  payload: error,
});
